/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Show ICD10 attribute content
 */
import { Modal, Typography } from 'antd';
import { useState } from 'react';

import EventTracker from 'utils/eventTracker';
import { EVENTS } from 'app-constants/events';

export interface IProps {
	title: string;
	content: React.ReactNode;
	triggerText?: string;
}

const ShowICD10Attribute: React.FC<IProps> = ({ title, content, triggerText = 'See more' }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			<Typography.Link
				data-testid='ce-icd10-see-more-link'
				underline
				onClick={() => {
					setIsOpen(true);
					EventTracker.trackEvent(EVENTS.codeExplorer.codeAttributeSeeMoreClicked(title));
				}}
			>
				{triggerText}
			</Typography.Link>
			<Modal
				data-testid='ce-icd10-attr-modal'
				open={isOpen}
				onCancel={() => setIsOpen(false)}
				footer={null}
				centered
				width={'80%'}
				title={title}
				classNames={{ body: 'max-h-[600px] py-4 px-6 overflow-auto flex flex-col' }}
				destroyOnHidden
			>
				<div className='whitespace-pre-line'>{content}</div>
			</Modal>
		</>
	);
};

export default ShowICD10Attribute;
